import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useListLeagueHomeVenues } from "../api/LeagueVenueApiProvider";
import { useCreateLeagueMatch } from "../api/SeasonApiProvider";
import { Loading } from "../nav/Loading";
import { LeagueSeasonGuardFallback, useLeagueSeasonGuard, } from "../seasons/useLeagueSeasonGuard";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { LeagueMatchForm } from "./LeagueMatchForm";
export const CreateLeagueMatch = () => {
    const { leagueId, seasonId } = useNumericParams();
    const navigate = useNavigate();
    const guard = useLeagueSeasonGuard({ leagueId, seasonId });
    const { data: leagueVenues = [], isLoading: venuesLoading } = useListLeagueHomeVenues({
        leagueId,
        enabled: guard.status === "ready",
    });
    const mutation = useCreateLeagueMatch({
        onSuccess: (response) => {
            navigate(`/leagues/${leagueId}/seasons/${seasonId}?tab=fixtures&division=${response.data.division}`);
        },
    });
    const onSubmit = (data) => {
        mutation.mutate(data);
    };
    if (guard.status !== "ready") {
        return _jsx(LeagueSeasonGuardFallback, { guard: guard });
    }
    if (venuesLoading) {
        return _jsx(Loading, {});
    }
    const divisions = guard.season.divisions ?? [];
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: "Create League Match" }) }), _jsx(LeagueMatchForm, { divisions: divisions, leagueVenues: leagueVenues, onSubmit: onSubmit, isSubmitting: mutation.isLoading })] }));
};
